import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  Typography,
  Box,
} from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

export const CardLayout2 = ({
  value,
  setValue,
  limit,
  register_page,
  page,
  setPage,
  open,
  setOpen,
  btn_label,
  default_btn_label,
  option_values,
  subtitle,
  popup_label,
  popup_content,
  icon,
  sendMongoDBRegistration,
  required,
}) => {
  const toggleDialog1 = () => {
    setOpen(!open);
  };

  const [visible2, setVisible2] = useState(false);
  const toggleDialog2 = () => {
    setVisible2(!visible2);
  };

  const [chosen, setChosen] = useState("");

  useEffect(() => {
    setChosen(value);
  }, [open]);

  useEffect(() => {
    if (chosen !== value) {
      setValue(chosen);
    }
  }, [chosen]);

  return (
    <>
      {chosen.length === 0 && required && (
        <Typography color="error" variant="body2">
          This field is required.
        </Typography>
      )}
      {!register_page && (
        <List>
          <ListItem
            button
            onClick={toggleDialog1}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "16px",
              border: `1px solid ${chosen.length === 0 && required ? "red" : "#ccc"}`,
              borderRadius: "8px",
              marginBottom: "8px",
            }}
          >
            <ListItemText primary={icon} />
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography variant="body2" sx={{ textAlign: "center" }}>
                {default_btn_label}
              </Typography>
              <ChevronRightIcon />
            </Box>
          </ListItem>
        </List>
      )}
      <Dialog open={open} onClose={toggleDialog1}>
        <DialogTitle sx={{ textAlign: "center" }}>{btn_label}</DialogTitle>
        <DialogContent>
          <Typography variant="h6" sx={{ textAlign: "center" }}>
            {icon}
          </Typography>
          <Typography variant="body2" sx={{ textAlign: "center" }}>
            {subtitle}
          </Typography>
          <Typography
            variant="body2"
            sx={{ textAlign: "center", cursor: "pointer", color: "blue" }}
            onClick={toggleDialog2}
          >
            {popup_label}
          </Typography>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: "8px", marginTop: "16px" }}>
            {option_values.map((item, i) => (
              <Button
                key={i}
                variant={chosen.includes(item) ? "contained" : "outlined"}
                onClick={() => {
                  !chosen.includes(item)
                    ? setChosen([...chosen.filter((item) => item !== ""), item])
                    : setChosen(chosen.filter((oldValue) => oldValue !== item));
                }}
              >
                {item}
              </Button>
            ))}
          </Box>
        </DialogContent>
        <DialogActions>
          <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
            {limit !== 0 && limit + 1 <= chosen.length && (
              <Typography color="error" variant="body2">
                Must choose only 1 value.
              </Typography>
            )}
            <Box sx={{ display: "flex", justifyContent: "space-between", marginTop: "16px" }}>
              {register_page ? (
                <Button
                  variant="contained"
                  disabled={limit !== 0 && limit + 1 <= chosen.length}
                  onClick={() => {
                    setPage(page + 1);
                    setValue(chosen);
                    sendMongoDBRegistration();
                  }}
                >
                  NEXT
                </Button>
              ) : (
                <Button
                  variant="contained"
                  onClick={() => {
                    setValue(chosen);
                    sendMongoDBRegistration();
                    setOpen(false);
                  }}
                >
                  SAVE
                </Button>
              )}
            </Box>
            <Box sx={{ display: "flex", justifyContent: "space-between", marginTop: "8px" }}>
              {register_page ? (
                <Button
                  variant="text"
                  onClick={() => (page > 0 ? setPage(page - 1) : console.log("this is page 1"))}
                >
                  BACK
                </Button>
              ) : (
                <Button variant="text" onClick={() => setOpen(false)}>
                  CANCEL
                </Button>
              )}
            </Box>
          </Box>
        </DialogActions>
      </Dialog>
      <Dialog open={visible2} onClose={toggleDialog2}>
        <DialogTitle>{btn_label}</DialogTitle>
        <DialogContent>{popup_content}</DialogContent>
      </Dialog>
    </>
  );
};